import { BaseEntity } from '../../../../models';
import { CidadeSubRegiao } from '../../../cidade/sub-regiao';
import { RegiaoCidadeSubRegiaoBairro } from './regiao-cidade-sub-regiao-bairro';

export class RegiaoCidadeSubRegiao implements BaseEntity {
    readonly id: number;
    idRegiaoCidade: number;
    idCidadeSubRegiao: number;
    cidadeSubRegiao: CidadeSubRegiao;
    bairros: RegiaoCidadeSubRegiaoBairro[];

    // Atributos auxiliares
    isChecked: boolean;

    constructor() {
        this.bairros = [];
    }
}
